import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_PATIENT_REQUESTS_ANCHOR } from '../anchors';

/**
 * Bumped to version 2 when the right-side urgent/routine number badges were
 * replaced by an inline color-coded breakdown in the status row.
 */
export const dashboardPatientRequestsHint: Hint = {
  id: asHintId('dashboard:patient-requests'),
  version: 2,
  priority: 40,
  anchor: DASHBOARD_PATIENT_REQUESTS_ANCHOR,
  copy: {
    title: 'Open requests',
    body: 'Each row shows a patient’s open requests inline — red text is urgent, orange is routine. Higher counts usually mean a longer encounter.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
